import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafePipeModule } from 'safe-pipe';

import { Directives } from './directives';
import { Pipes } from './pipes';

@NgModule({
  imports: [CommonModule],
  declarations: [Pipes, Directives],
  providers: [Pipes],
  exports: [Pipes, Directives, SafePipeModule]
})
export class SharedModule {}
